<template>
  <a :href="integrateIOURL" class="fly-box logo-container">
    <FlyDataLogoIcon />
  </a>
</template>
<script>
import FlyDataLogoIcon from 'shared/components/Icon/FlyDataLogoIcon';
import CONFIG from 'shared/config';

export default {
  name: 'AppNavbarLogo',
  components: {
    FlyDataLogoIcon,
  },
  computed: {
    integrateIOURL() {
      return CONFIG.INTEGRATEIO_URL;
    },
  },
};
</script>

<style scoped>
.logo-container {
  display: flex;
  flex-flow: column;
  padding: 16px;
  cursor: pointer;
}
</style>
